import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "src/hooks/useTheme";

// Auth pages (login/register/forgot/reset) have no topbar, so there's
// nowhere else to put the theme switch that exists everywhere else in the
// app — floats top-center on desktop, top-right on mobile.
const AuthThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className="fixed right-4 top-4 z-20 rounded-full border border-gray-200 bg-white p-2 text-gray-500 shadow-sm hover:bg-gray-100 hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-100 md:left-1/2 md:right-auto md:-translate-x-1/2"
      aria-label="Toggle theme"
      onClick={toggleTheme}
    >
      {theme === "dark" ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
};

export default AuthThemeToggle;
